import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Real-time scrolling ticker of major Indian + Global symbols.
// Refreshes every 30s; backend caches Yahoo Finance for 60s.
const INDIAN_TICKER_LABELS = ["NIFTY", "BANKNIFTY", "SENSEX"];

export default function LiveTicker({ scope = "all" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancel = false;
    const load = async () => {
      try {
        const { data } = await api.get("/ticker");
        if (!cancel) setItems(data?.items || []);
      } catch {}
    };
    load();
    const id = setInterval(load, 30000);
    return () => { cancel = true; clearInterval(id); };
  }, []);

  const visible = scope === "indian" ? items.filter((it) => INDIAN_TICKER_LABELS.includes(it.label)) : items;
  if (visible.length === 0) return null;
  // Duplicate items to allow seamless looping marquee.
  const loop = [...visible, ...visible];

  return (
    <div className="border-b border-zinc-900 bg-black overflow-hidden" data-testid="live-ticker">
      <div className="flex animate-ticker whitespace-nowrap py-2">
        {loop.map((it, idx) => {
          const up = it.change_pct >= 0;
          const color = up ? "text-[#22C55E]" : "text-[#EF4444]";
          const fmt = it.category === "Forex"
            ? it.price.toFixed(4)
            : it.price >= 1000
              ? it.price.toLocaleString("en-IN", { maximumFractionDigits: 2 })
              : it.price.toFixed(2);
          return (
            <div key={idx} className="flex items-center gap-2 px-5 text-[12px] font-mono" data-testid={`ticker-${it.label}`}>
              <span className="text-zinc-400 uppercase tracking-widest">{it.label}</span>
              <span className="text-zinc-200">{fmt}</span>
              <span className={`${color} font-bold`}>{up ? "▲" : "▼"} {Math.abs(it.change_pct).toFixed(2)}%</span>
              <span className="text-zinc-800">·</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
